import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import Swal from "sweetalert2";
import {
  Paper,
  Typography,
  Box,
  TextField,
  InputAdornment,
  Chip,
  Stack,
  Divider,
} from "@mui/material";

// Iconos MUI
import SearchIcon from "@mui/icons-material/Search";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import StorefrontIcon from "@mui/icons-material/Storefront";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import GroupsIcon from "@mui/icons-material/Groups";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ScienceIcon from "@mui/icons-material/Science";
import TransformIcon from "@mui/icons-material/Transform";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import CancelIcon from "@mui/icons-material/Cancel";
import BusinessIcon from "@mui/icons-material/Business";
import HandshakeIcon from "@mui/icons-material/Handshake";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import BadgeIcon from "@mui/icons-material/Badge";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import PrintIcon from "@mui/icons-material/Print";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import BiotechIcon from "@mui/icons-material/Biotech";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import SendToMobileIcon from "@mui/icons-material/SendToMobile";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import SendAndArchiveIcon from "@mui/icons-material/SendAndArchive";
import TodayIcon from "@mui/icons-material/Today";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

const Informes = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("TODOS");

  useEffect(() => {
    document.title = "Informes y Reportes";
  }, []);

  // Definición de los 29 Informes organizados por categoría
  const informesList = [
    // 1. FINANZAS
    {
      id: 1,
      titulo: "Reporte Financiero",
      categoria: "FINANZAS",
      color: "#ab47bc",
      descripcion: "Muestra las ganancias netas del laboratorio",
      icon: <AttachMoneyIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 2,
      titulo: "Corte de Caja",
      categoria: "FINANZAS",
      color: "#ab47bc",
      descripcion: "Muestra las entradas y salidas de efectivo, independientemente de los cortes parciales que se hayan realizado en el día en curso",
      icon: <PointOfSaleIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 3,
      titulo: "Ingresos en Sucursales",
      categoria: "FINANZAS",
      color: "#ab47bc",
      descripcion: "Muestra el total de ingresos generados en las sucursales activas",
      icon: <StorefrontIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 4,
      titulo: "Solicitudes no Liquidadas",
      categoria: "FINANZAS",
      color: "#ab47bc",
      descripcion: "Muestra el detalle de las solicitudes que no se han pagado",
      icon: <MoneyOffIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 6,
      titulo: "Descuentos",
      categoria: "FINANZAS",
      color: "#ab47bc",
      descripcion: "Muestra aquellas solicitudes que se les realizó descuento por Cantidad y Por porcentaje únicamente en un rango de fechas",
      icon: <LocalOfferIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },

    // 2. PACIENTES
    {
      id: 7,
      titulo: "Estadísticas de Pacientes",
      categoria: "PACIENTES",
      color: "#0288d1",
      descripcion: "Muestra las estadísticas de pacientes recurrentes y visita única",
      icon: <GroupsIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },

    // 3. SOLICITUDES
    {
      id: 8,
      titulo: "Número de Solicitudes",
      categoria: "SOLICITUDES",
      color: "#006787",
      descripcion: "Muestra la cantidad de solicitudes realizadas en las sucursales activas",
      icon: <AssignmentIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 13,
      titulo: "Solicitudes Canceladas",
      categoria: "SOLICITUDES",
      color: "#d32f2f",
      descripcion: "Muestra el detalle de las solicitudes o estudios que se cancelaron",
      icon: <CancelIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 26,
      titulo: "Solicitudes Generadas",
      categoria: "SOLICITUDES",
      color: "#006787",
      descripcion: "Muestra el detalle de las solicitudes generadas en las sucursales activas",
      icon: <NoteAddIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },

    // 4. OPERACIONES
    {
      id: 9,
      titulo: "Número de Estudios",
      categoria: "OPERACIONES",
      color: "#2e7d32",
      descripcion: "Muestra el nombre y cantidad del estudio solicitado en las sucursales activas",
      icon: <ScienceIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 17,
      titulo: "Catálogo de Estudios",
      categoria: "OPERACIONES",
      color: "#2e7d32",
      descripcion: "Muestra el catálogo de estudios que está cargado para su laboratorio",
      icon: <FormatListBulletedIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 28,
      titulo: "Orden del Día",
      categoria: "OPERACIONES",
      color: "#2e7d32",
      descripcion: "Muestra el nombre del paciente y estudio solicitado por el paciente",
      icon: <TodayIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },

    // 5. DOCTORES Y EMPRESAS
    {
      id: 12,
      titulo: "Doctores Remitidos",
      categoria: "DOCTORES Y EMPRESAS",
      color: "#e65100",
      descripcion: "Muestra los doctores registrados en las solicitudes, así como los insertados en el módulo de doctores",
      icon: <MedicalServicesIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 15,
      titulo: "Convenios en Solicitudes",
      categoria: "DOCTORES Y EMPRESAS",
      color: "#e65100",
      descripcion: "Filtra solicitudes que involucran convenios con empresas",
      icon: <HandshakeIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },
    {
      id: 16,
      titulo: "Pacientes de Empresas",
      categoria: "DOCTORES Y EMPRESAS",
      color: "#e65100",
      descripcion: "Mostrará el total de pacientes atendidos por empresas",
      icon: <Diversity3Icon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },

    // 6. ADMINISTRACIÓN
    {
      id: 19,
      titulo: "Plantilla de Empleados",
      categoria: "ADMINISTRACIÓN",
      color: "#546e7a",
      descripcion: "Muestra los empleados registrados dentro del sistema",
      icon: <BadgeIcon sx={{ fontSize: "2.2rem", color: "#ffffff" }} />,
    },

  ];

  // Orden estricto de secciones requerido por el usuario
  const orderedSections = [
    { key: "FINANZAS", title: "1. Finanzas y Caja", color: "#ab47bc" },
    { key: "PACIENTES", title: "2. Pacientes", color: "#0288d1" },
    { key: "SOLICITUDES", title: "3. Solicitudes y Cotizaciones", color: "#006787" },
    { key: "OPERACIONES", title: "4. Operaciones y Estudios", color: "#2e7d32" },
    { key: "DOCTORES Y EMPRESAS", title: "5. Doctores y Empresas", color: "#e65100" },
    { key: "ADMINISTRACIÓN", title: "6. Administración y Personal", color: "#546e7a" },
  ];

  const categoriesFilter = [
    "TODOS",
    "FINANZAS",
    "PACIENTES",
    "SOLICITUDES",
    "OPERACIONES",
    "DOCTORES Y EMPRESAS",
    "ADMINISTRACIÓN",
  ];

  const handleCardClick = (informe) => {
    const navState = { state: { fromApp: true } };
    if (informe.id === 1 || informe.titulo === "Reporte Financiero") {
      navigate("/reporteFinanciero", navState);
      return;
    }
    if (informe.id === 2 || informe.titulo === "Corte de Caja") {
      navigate("/reporteCaja", navState);
      return;
    }
    if (informe.id === 3 || informe.titulo === "Ingresos en Sucursales") {
      navigate("/ingresosSucursales", navState);
      return;
    }
    if (informe.id === 4 || informe.titulo === "Solicitudes no Liquidadas") {
      navigate("/solicitudesNoLiquidadas", navState);
      return;
    }
    if (informe.id === 5 || informe.titulo === "Reporte de Descuentos" || informe.titulo === "Descuentos") {
      navigate("/reporteDescuentos", navState);
      return;
    }
    if (informe.id === 7 || informe.titulo === "Estadísticas de Pacientes") {
      navigate("/estadisticasPacientes", navState);
      return;
    }
    if (informe.id === 8 || informe.titulo === "Número de Solicitudes") {
      navigate("/numeroSolicitudes", navState);
      return;
    }
    if (informe.id === 13 || informe.titulo === "Solicitudes Canceladas") {
      navigate("/solicitudesCanceladas", navState);
      return;
    }
    if (informe.id === 26 || informe.titulo === "Solicitudes Generadas") {
      navigate("/solicitudesGeneradas", navState);
      return;
    }
    if (informe.id === 9 || informe.titulo === "Número de Estudios" || informe.titulo === "Estudios") {
      navigate("/numeroEstudios", navState);
      return;
    }
    if (informe.id === 10 || informe.titulo === "Catálogo de Estudios" || informe.titulo === "Catálogo") {
      navigate("/catalogoEstudios", navState);
      return;
    }
    if (informe.id === 28 || informe.titulo === "Orden del Día" || informe.titulo === "Orden Dia") {
      navigate("/ordenDia", navState);
      return;
    }
    if (informe.id === 12 || informe.titulo === "Doctores Remitidos") {
      navigate("/doctoresRemitidos", navState);
      return;
    }
    if (informe.id === 15 || informe.titulo === "Convenios en Solicitudes" || informe.titulo === "ConveniosSolicitudes") {
      navigate("/conveniosSolicitudes", navState);
      return;
    }
    if (informe.id === 16 || informe.titulo === "Pacientes de Empresas" || informe.titulo === "PacientesEmpresas") {
      navigate("/pacientesEmpresas", navState);
      return;
    }
    if (informe.id === 19 || informe.titulo === "Plantilla de Empleados" || informe.titulo === "PlantillaEmpleados") {
      navigate("/plantillaEmpleados", navState);
      return;
    }

    Swal.fire({
      title: informe.titulo,
      text: `Has seleccionado el informe: "${informe.titulo}". Esta función está lista para conectarse con sus reportes.`,
      icon: "info",
      confirmButtonColor: "#006787",
      confirmButtonText: "Aceptar",
    });
  };

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            padding: { xs: "16px", sm: "24px 32px", md: "24px 40px" },
            width: "100%",
            maxWidth: "1600px",
            margin: "0 auto",
            boxSizing: "border-box",
            overflowX: "hidden",
            minHeight: "85vh",
          }}
        >
          {/* Header principal */}
          <Paper
            elevation={3}
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: "16px",
              background: "linear-gradient(135deg, #006787 0%, #014e65 100%)",
              color: "white",
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{ fontFamily: "Roboto-Medium", letterSpacing: "0.5px" }}
              >
                Módulo de Informes y Reportes
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                Selecciona una opción para generar el reporte detallado del sistema
              </Typography>
            </Box>

            {/* Buscador inteligente */}
            <TextField
              variant="outlined"
              size="small"
              placeholder="Buscar informe por nombre o palabra clave..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                width: { xs: "100%", md: "380px" },
                backgroundColor: "white",
                borderRadius: "10px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#006787" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Paper>

          {/* Filtro por Categorías */}
          <Stack
            direction="row"
            spacing={1}
            sx={{
              mb: 3,
              overflowX: "auto",
              pb: 1,
              "&::-webkit-scrollbar": { height: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#ccc",
                borderRadius: "3px",
              },
            }}
          >
            {categoriesFilter.map((cat) => (
              <Chip
                key={cat}
                label={cat}
                clickable
                onClick={() => setSelectedCategory(cat)}
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.75rem",
                  px: 1,
                  py: 0.5,
                  backgroundColor:
                    selectedCategory === cat ? "#006787" : "#e0e0e0",
                  color: selectedCategory === cat ? "#ffffff" : "#424242",
                  "&:hover": {
                    backgroundColor:
                      selectedCategory === cat ? "#014e65" : "#d5d5d5",
                  },
                }}
              />
            ))}
          </Stack>

          {/* Secciones Ordenadas por Categoría */}
          {orderedSections.map((section) => {
            if (
              selectedCategory !== "TODOS" &&
              selectedCategory !== section.key
            ) {
              return null;
            }

            const itemsInSection = informesList.filter((item) => {
              const matchesSection = item.categoria === section.key;
              const matchesSearch =
                item.titulo.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.descripcion.toLowerCase().includes(searchQuery.toLowerCase());
              return matchesSection && matchesSearch;
            });

            if (itemsInSection.length === 0) return null;

            return (
              <Box key={section.key} sx={{ mb: 4 }}>
                {/* Encabezado de Sección */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 1.5,
                    mt: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: "12px",
                      height: "24px",
                      backgroundColor: section.color,
                      borderRadius: "4px",
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: "#ffffff",
                      fontSize: "1.15rem",
                      fontFamily: "Roboto-Medium",
                    }}
                  >
                    {section.title}
                  </Typography>
                </Box>

                <Divider sx={{ backgroundColor: "rgba(255,255,255,0.15)", mb: 2.5 }} />

                {/* Grid de tarjetas para esta sección (Exactamente 3 por fila, sin compartir fila entre categorías) */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "repeat(1, 1fr)",
                      sm: "repeat(2, 1fr)",
                      md: "repeat(3, 1fr)",
                      lg: "repeat(3, 1fr)",
                    },
                    gap: "20px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  {itemsInSection.map((item) => (
                    <Paper
                      key={item.id}
                      elevation={2}
                      onClick={() => handleCardClick(item)}
                      sx={{
                        p: 2.5,
                        borderRadius: "14px",
                        minHeight: "180px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#ffffff",
                        transition: "all 0.25s ease-in-out",
                        cursor: "pointer",
                        border: "1px solid #e2e8f0",
                        position: "relative",
                        boxSizing: "border-box",
                        "&:hover": {
                          transform: "translateY(-6px)",
                          boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                          borderColor: item.color,
                        },
                      }}
                    >
                      {/* Encabezado de Tarjeta */}
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.8 }}>
                        <Box
                          sx={{
                            width: "55px",
                            height: "55px",
                            minWidth: "55px",
                            borderRadius: "50%",
                            backgroundColor: item.color,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: `0 4px 10px ${item.color}55`,
                          }}
                        >
                          {item.icon}
                        </Box>

                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: "1rem",
                              fontWeight: "bold",
                              color: "#1a202c",
                              lineHeight: 1.2,
                              fontFamily: "Roboto-Medium",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={item.titulo}
                          >
                            {item.titulo}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "0.65rem",
                              fontWeight: "800",
                              color: item.color,
                              letterSpacing: "0.8px",
                              display: "block",
                              mt: 0.3,
                            }}
                          >
                            {item.categoria}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Divisor de color */}
                      <Box
                        sx={{
                          height: "3.5px",
                          backgroundColor: item.color,
                          borderRadius: "2px",
                          my: 1.5,
                          width: "100%",
                        }}
                      />

                      {/* Descripción */}
                      <Typography
                        variant="body2"
                        align="center"
                        sx={{
                          color: "#4a5568",
                          fontSize: "0.75rem",
                          lineHeight: 1.35,
                          fontWeight: "500",
                          flexGrow: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {item.descripcion}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              </Box>
            );
          })}

          {/* Mensaje de no resultados */}
          {informesList.filter((item) =>
            item.titulo.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.descripcion.toLowerCase().includes(searchQuery.toLowerCase())
          ).length === 0 && (
              <Box
                sx={{
                  textAlign: "center",
                  py: 8,
                  color: "#cbd5e0",
                }}
              >
                <Typography variant="h6">
                  No se encontraron informes que coincidan con la búsqueda.
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Intenta con otra palabra clave o selecciona la categoría "TODOS".
                </Typography>
              </Box>
            )}
        </Box>
      </Content>
    </Layout>
  );
};

export default Informes;
